import { SharepointIcon } from "#components/ui/SharepointIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const sharepointManifest: IntegrationManifest = {
    key: "sharepoint",
    displayName: "SharePoint",
    nameKey: "channels.sharepoint",
    descriptionKey: "sharepointDescription",
    trayDescriptionKey: "composerTrayDescriptions.sharepoint",
    cardDescriptionKey: "connectIntegration.descriptions.sharepoint",
    connectedContentKeys: ["sharepointSites", "sharepointDocuments"],
    brandColor: "#038387",
    iconUrl: IconAssets.Sharepoint,
    iconUrlAlt: IconAssets.SharepointAlt,
    glyph: SharepointIcon,
    channelType: "UserSharepoint",
    dataSources: ["sharepoint_page", "sharepoint_file"]
};
